import clsx from 'classnames';
import { HTMLAttributes } from 'react';
import styles from './mvp-card.module.css';

export interface MvpCardProps extends HTMLAttributes<HTMLDivElement> {}
export default function MvpCard({
  children,
  className,
}: MvpCardProps): JSX.Element {
  return <div className={clsx(styles.mvpCard, className)}>{children}</div>;
}
